/**
 * Builds a CSS media query string from query type and value.
 *
 * @param mediaQuery - The media query type (e.g., 'min-width', 'max-width')
 * @param mediaValue - The media query value (e.g., '992px', '767.5px')
 * @returns Formatted media query string (e.g., '(min-width: 992px)') or empty string if params are missing
 *
 * @example
 * buildMediaQuery('min-width', '992px'); // '(min-width: 992px)'
 * buildMediaQuery('max-width', '767px'); // '(max-width: 767px)'
 */
export const buildMediaQuery = (mediaQuery?: string, mediaValue?: string): string => {
  if (!mediaQuery || !mediaValue) return '';
  return `(${mediaQuery}: ${mediaValue})`;
};

/**
 * Extracts the first URL from a srcset string or returns the URL as-is.
 * srcset strings can contain multiple URLs with width descriptors (e.g., "url1.jpg 1x, url2.jpg 2x").
 *
 * @param srcSetOrUrl - A srcset string or single URL
 * @returns The first URL extracted from the srcset
 *
 * @example
 * getHrefFromSrcSetOrUrl('image.jpg?w=800'); // 'image.jpg?w=800'
 * getHrefFromSrcSetOrUrl('image.jpg 1x, image2.jpg 2x'); // 'image.jpg'
 * getHrefFromSrcSetOrUrl('image.jpg 800w, image2.jpg 1600w'); // 'image.jpg'
 */
export const getHrefFromSrcSetOrUrl = (srcSetOrUrl: string): string => {
  return srcSetOrUrl.split(',')[0].trim().split(/\s+/)[0];
};
